import variables from '../variables'

import type { CheckboxOverrideToken } from './types'

const Checkbox: CheckboxOverrideToken = {
  colorPrimaryHover: variables.brandBlue80,
  colorTextDisabled: variables.gray60,
  colorBgContainerDisabled: variables.gray20
} as const

export default Checkbox
